import * as types from "./types";

const appState = {
  user: null,
  error: null
};

export default (state = appState, action) => {
  switch (action.type) {
    case types.CLEAR_STORE: {
      return {
        ...state,
        ...appState
      };
    }
    case types.FETCHING_USER_SUCCESS: {
      return {
        ...state,
        user: action.payload
      };
    }
    case types.FETCHING_USER_ERROR: {
      return {
        ...state,
        error: action.payload
      };
    }
    default:
      return state;
  }
};
